import { ALL_PERMISSION_KEYS, getDefaultPermissions, getRolePermissionCaps } from "./permissionsCatalog";

export const can = (permisos, permiso) => permisos?.[permiso] === true;

export const buildRolePermissions = (role, roleDoc = {}) => {
  const requested = {
    ...getDefaultPermissions(role),
    ...(roleDoc?.permisos || {}),
  };
  const caps = getRolePermissionCaps(role);

  return ALL_PERMISSION_KEYS.reduce((acc, permission) => {
    acc[permission] = caps[permission] === true && requested[permission] === true;
    return acc;
  }, {});
};

export const canRole = (role, permiso, roleDoc = {}) =>
  can(buildRolePermissions(role, roleDoc), permiso);
